import { FDStat } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import React from 'react';
import { useDataAttrs } from 'Helpers/Testing';

const Stat = ({ value, label, ...rest }) => {
  return (<FDStat
    {...useDataAttrs(rest)}
    value={value}
    label={label}
  />);
};

Stat.defaultProps = {
  value: '',
};

Stat.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
};

export { Stat };
